import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  skillSheets: []
};

// getters
export const getters = {
  skillSheets: state => state.skillSheets
};

// mutations
export const mutations = {
  [types.SKILLSHEET.FETCH_SKILLSHEET](state, skillSheets) {
    state.skillSheets = skillSheets;
  }
};

// actions
export const actions = {
  async fetchSkillSheet({ commit }) {
    const response = await axios.get(api.LIST_SKILL_SHEET);
    commit(types.SKILLSHEET.FETCH_SKILLSHEET, response.data);
  },

  // eslint-disable-next-line
  async createSkillSheet({ commit }, params) {
    await axios.post(api.CREATE_SKILL_SHEET, params);
  }
};
